import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#8C9396"
      d="M5.474 3.111 6.77 4.288 4.912 6.331h7.349v1.75H4.925l1.863 2.034-1.29 1.183-3.748-4.09 3.724-4.097Z"
    />
  </svg>
);
export default SvgComponent;
